import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { Link } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import { db } from "../firebaseConfig";
import "../css/App.css";

export default function ContactPage() {
    const [form, setForm] = useState({
        firstName: "",
        lastName: "",
        email: "",
        message: "",
    });
    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("Sending...");
        try {
            await addDoc(collection(db, "contacts"), {
                firstName: form.firstName,
                lastName: form.lastName,
                email: form.email,
                message: form.message,
                createdAt: serverTimestamp(),
            });
            setStatus("Message sent! We'll be in touch soon.");
            setForm({ firstName: "", lastName: "", email: "", message: "" });
        } catch (err) {
            console.error("Firestore error", err);
            setStatus("Failed to send. Please try again.");
        }
    };

    return (
        <>
            <Navbar />
            <main className="subscribe-page">
                <div className="subscribe-hero">
                    <h1>Contact Us</h1>
                    <p>Have questions or need more info? Reach out using the form below.</p>
                    <form className="subscribe-form" onSubmit={handleSubmit}>
                        <input
                            name="firstName"
                            type="text"
                            placeholder="First Name"
                            value={form.firstName}
                            onChange={handleChange}
                            required
                            className="subscribe-input"
                        />
                        <input
                            name="lastName"
                            type="text"
                            placeholder="Last Name"
                            value={form.lastName}
                            onChange={handleChange}
                            required
                            className="subscribe-input"
                        />
                        <input
                            name="email"
                            type="email"
                            placeholder="Email Address"
                            value={form.email}
                            onChange={handleChange}
                            required
                            className="subscribe-input"
                        />
                        <textarea
                            name="message"
                            placeholder="Your Message"
                            value={form.message}
                            onChange={handleChange}
                            className="subscribe-input"
                            rows={4}
                            required
                        />
                        <button type="submit" className="subscribe-button">
                            Send Message
                        </button>
                    </form>
                    <div style={{ textAlign: "center", margin: "1rem 0" }}>
                        <span style={{ fontSize: "0.95rem", color: "#4a4a4a", marginRight: "0.5rem" }}>
                            Want to join our mailing list?
                        </span>
                        <Link to="/subscribe" style={{ fontSize: "0.95rem", fontWeight: 600 }}>
                            Subscribe here.
                        </Link>
                    </div>
                    {status && <p className="subscribe-status">{status}</p>}
                </div>
            </main>
            <Footer />
        </>
    );
}